module.exports = {
    version: 5,
    environment: process.env.ENV,
    development: {
        client : "http://localhost:3000",
        server : "http://localhost:8080",
        rootPath : "",
        staticFilesRootPath : "",
        mainSiteUrl: "",
        apiServer: "https://admin.hankix.fi"
    },
    production: {
        client : "",
        server : "",
        rootPath : "",
        staticFilesRootPath : "/hankikuntotarkastus",
        mainSiteUrl: "",
        apiServer: "https://admin.hankix.fi"
    },
    browserSyncStartPath : "/"
}

